import { CalendarSyncEntry } from '@griply/types';
import { getCalendarSyncs } from '@griply/utils';
import { useMemo } from 'react';

import { useExternalCalendarConnections } from './use-external-calendar-connections';

// Platform twin: both apps wrap the shared getCalendarSyncs in one useMemo (the Option-A
// shape in rules/packages.md) — the query hook it reads is per-app, so the hook can't be shared.
export const useCalendarSyncs = (): CalendarSyncEntry[] => {
  const connections = useExternalCalendarConnections();

  return useMemo(() => getCalendarSyncs(connections), [connections]);
};
